import * as packageInfo from '../../../../package.json'
import { RouteUrl } from '@core/enums/routing.enums'

// FIXME Check if better to use regex
export const URL_SAVE_BLACKLIST = [
  RouteUrl.Login,
  RouteUrl.AuthMain,
  RouteUrl.NotPermitted,
  RouteUrl.UpdateVersion,
  RouteUrl.UserDisallowed
].map((page) => new RegExp(`^${page}$`))

export const APP_VERSION = packageInfo['default']?.version
